<div mat-dialog-content>
  <div class="success-image"></div>
  <div class="title title-lg confirm-dialog-text">Ok!</div>
</div>
